import { render, staticRenderFns } from "./MovimientoDetail.vue?vue&type=template&id=5c926152&scoped=true"
import script from "./MovimientoDetail.vue?vue&type=script&lang=js"
export * from "./MovimientoDetail.vue?vue&type=script&lang=js"
import style0 from "./MovimientoDetail.vue?vue&type=style&index=0&id=5c926152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c926152",
  null
  
)

export default component.exports